export default __webpack_public_path__ + "static/media/buffer-and-reagent-solutions.ffaa9c02.png";